module.exports = __webpack_public_path__ + "img/signathor_transparent.d096516a.webp";